const headerWidth = () => {
    const header = $('.js-website-header');

    if ( header.length ) {
        header.css({
            'max-width' : window.deviceWidth
        });
        $('.top-navigation__dropdown').css({
            'max-width' : window.deviceWidth
        });
    }
}